import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";
import { Send } from "lucide-react";
import { AISuggestedPrompts } from "@/components/ai-assistant/AISuggestedPrompts";

/**
 * The bottom composer of the DriveDesk AI widget: follow-up suggested
 * prompts (once a conversation has started) plus the text input and send
 * button. Extracted from DriveDeskAIWidget.js for the same reason as
 * AIChatMessageList — keep the widget itself a thin shell.
 */
export const AIChatComposer = ({
  draft,
  onDraftChange,
  onKeyDown,
  onSend,
  sending,
  suggestions,
  hasMessages,
  onPickSuggestion,
}) => {
  return (
    <div className="p-3 border-t space-y-2">
      {hasMessages && (
        <AISuggestedPrompts prompts={suggestions.slice(0, 3)} onPick={onPickSuggestion} disabled={sending} />
      )}
      <div className="flex items-end gap-2">
        <Textarea
          value={draft}
          onChange={(e) => onDraftChange(e.target.value)}
          onKeyDown={onKeyDown}
          placeholder="Ask Your AI Office Manager..."
          className="min-h-[44px] max-h-32 resize-none"
          disabled={sending}
          data-testid="ai-assistant-input"
        />
        <Button
          size="icon"
          className="h-11 w-11 shrink-0 bg-[hsl(var(--role-accent))] hover:opacity-95"
          onClick={onSend}
          disabled={sending || !draft.trim()}
          data-testid="ai-assistant-send-button"
        >
          <Send className="h-4 w-4" />
        </Button>
      </div>
    </div>
  );
};
